/** @format */

import {Operator} from 'types';

import {Tab} from './types';

export const KPI_SENSORS = ['as-kpi-age-gender', 'as-kpi-place', 'as-kpi-geo'];
export const MAX_BAD_WORDS = 3;
export const MAX_STOP_WORDS = 3;
export const SETTINGS_TAB = 'settings';
export const FILTERS_TAB = 'filters';

export const TABS: Tab[] = [
  {path: '#', name: SETTINGS_TAB, text: 'Основные'},
  {path: '#', name: FILTERS_TAB, text: 'Исключения'},
];

export const SENSORS_WITH_SETTINGS = [
  'as-geo',
  'as-bad-keys',
  'as-typo',
  'as-geo-name-mismatch',
  'as-ad-stop-words',
  'as-ad-double',
  'as-utm-coherency',
  'as-utm-format',
  'as-utm-format-appsflyer',
  'as-kpi-age-gender',
  'as-kpi-place',
  'as-kpi-geo',
  'as-strat-low-conv',
  'as-media-ad-anomaly-grow-cpm',
  'as-cpm-plan-exceeded',
  'as-campaign-anomaly-fall-vtr',
  'as-ad-anomaly-fall-visit-duration',
  'as-ad-anomaly-fall-page-depth',
];

export const NEW_ANOMALY_FALL_SENSORS = [
  'as-campaign-anomaly-fall-vtr',
  'as-ad-anomaly-fall-visit-duration',
  'as-ad-anomaly-fall-page-depth',
];

export const UTMS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content'];

export const TEXT_OPERATORS: Operator[] = [
  'EQUALS',
  'NOT_EQUALS',
  'NOT_CONTAINS',
  'CONTAINS',
  'START_WITH',
  'NOT_START_WITH',
  'END_WITH',
  'NOT_END_WITH',
];

export const MATH_OPERATORS: Operator[] = [
  'EQUALS',
  'NOT_EQUALS',
  'LESS',
  'MORE',
  'LESS_OR_EQ',
  'MORE_OR_EQ',
];

export const DATE_OPERATORS: Operator[] = ['EQUALS', 'NOT_EQUALS'];

export const NUMBER_FIELDS = [
  'actual_goal_price',
  'ad_title_length',
  'visits',
  'ad_title_restriction_length',
  'adgroup_ad_count',
  'adgroup_most_common_ad_count',
  'amount_remaining',
  'autotargeting_bid_network',
  'autotargeting_bid_search',
  'average_pos',
  'average_spend',
  'bid',
  'bounce_rate',
  'bounce_rate_percent',
  'clicks',
  'clicks_analysis',
  'clicks_before',
  'clicks_comparison',
  'clicks_delta_percent',
  'conversion_analysis',
  'conversion_comparison',
  'conversion_rate',
  'conversions',
  'conversions_before',
  'cpa',
  'cpa_analysis',
  'cpa_comparison',
  'cpa_limit',
  'cpc',
  'cpc_actual',
  'cpc_analysis',
  'cpc_comparison',
  'cpc_limit',
  'cpm_actual',
  'cpm_analysis',
  'cpm_comparison',
  'cpm_limit',
  'cr_analysis',
  'cr_comparison',
  'crr',
  'ctr',
  'ctr_analysis',
  'ctr_before',
  'ctr_comparison',
  'day_limit',
  'days_amount_remaining',
  'delta_percent',
  'feed_offer_doubles_cnt',
  'feed_offer_title_len',
  'feed_offer_title_len_limit',
  'first_page_cpc',
  'goal_id',
  'impressions',
  'impressions_before',
  'installs',
  'limit',
  'limit_goal_price',
  'median_ctr',
  'metric_diff',
  'metric_diff_abs',
  'metric_previous_value',
  'metric_value',
  'need_count',
  'nowork_minus_days',
  'overspent',
  'overspent_percent',
  'ratio',
  'spent',
  'spent_analysis',
  'spent_before',
  'spent_comparison',
  'spent_delta_percent',
  'spent_keys_conv',
  'spent_keys_noconv',
  'spent_ratio_keys_noconv',
  'spent_to_limit_percent',
  'views',
  'views_analysis',
  'views_before',
  'views_comparison',
  'views_per_user',
  'vtr_analysis',
  'vtr_comparison',
  'visit_duration_analysis',
  'visit_duration_comparison',
  'page_depth_analysis',
  'page_depth_comparison',
];

export const DATE_FIELDS = ['date', 'last_changed'];
